import styled from 'styled-components';

export const LinkButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0 10px 0 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;

export const CircleIcon = styled.div`
    width: 4rem;
    height: 4rem;
    border: 2px solid #F96302;
    border-radius: 50%;
    color:#F96302;
    text-align:center;
    margin-bottom: 10px;
    position: relative;

    &:after {
      content: "${({ id }) => `${id}`}";
      position: absolute;
      top: 8px;
      left: 50%;
      margin-left: -4px;
    }
`;

export const SectionWithBuffer = styled.section`
    margin-bottom: 1.6rem;
`;
